export default "\tquery getCurrentCustomer {\n\t\tgetCurrentCustomer {\n\t\t\temail\n\t\t\tfirstName\n\t\t\tlastName\n\t\t}\n\t}";